interface VideoIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const VideoIcon = (props: VideoIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M8.3,28.8V11.2c0-0.2,0.2-0.4,0.4-0.4h22.7c0.2,0,0.4,0.2,0.4,0.4v17.6c0,0.2-0.2,0.4-0.4,0.4H8.7
            C8.5,29.2,8.3,29,8.3,28.8z M30.9,13.3v-1.7h-1.7v1.7H30.9z M28.4,13.3v-1.7h-2.1v1.7H28.4z M25.5,13.3v-1.7h-2.1v1.7H25.5z
            M22.5,13.3v-1.7h-2.1v1.7H22.5z M19.6,13.3v-1.7h-2.1v1.7H19.6z M16.7,13.3v-1.7h-2.1v1.7H16.7z M13.7,13.3v-1.7h-2.1v1.7H13.7z
            M10.8,13.3v-1.7H9.1v1.7H10.8z M30.9,25.9V14.1H20.4v11.7H30.9z M19.6,25.9V14.1H9.1v11.7H19.6z M30.9,28.4v-1.7h-1.7v1.7H30.9z
            M28.4,28.4v-1.7h-2.1v1.7H28.4z M25.5,28.4v-1.7h-2.1v1.7H25.5z M22.5,28.4v-1.7h-2.1v1.7H22.5z M19.6,28.4v-1.7h-2.1v1.7H19.6z
            M16.7,28.4v-1.7h-2.1v1.7H16.7z M13.7,28.4v-1.7h-2.1v1.7H13.7z M10.8,28.4v-1.7H9.1v1.7H10.8z"
      />
    </svg>
  )
}

export default VideoIcon
